import React, { useEffect, useState } from 'react';
import AdminLayout from './AdminLayout';
import api from '../../services/api';

export default function SecurityManagement() {
  const [reports, setReports] = useState([]);

  useEffect(() => {
    let mounted = true;
    api.get('/security').then(res => { if (mounted) setReports(res.data); }).catch(err => console.error('Failed to load security reports', err));
    return () => { mounted = false; };
  }, []);

  return (
    <AdminLayout>
      <h2 className="text-xl font-bold mb-4">Security Management</h2>
      <table className="w-full bg-white shadow rounded border-collapse">
        <thead>
          <tr className="bg-gray-200 text-left">
            <th className="p-3">Event</th>
            <th className="p-3">Officer</th>
            <th className="p-3">Report</th>
            <th className="p-3">Status</th>
          </tr>
        </thead>
        <tbody>
          {reports.map(r => (
            <tr key={r.id} className="border-b">
              <td className="p-3">{r.event_id}</td>
              <td className="p-3">{r.officer_id}</td>
              <td className="p-3">{r.report}</td>
              <td className="p-3">{r.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </AdminLayout>
  );
}
